'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vouches = require('./vouches.html');

var _vouches2 = _interopRequireDefault(_vouches);

var _vouches3 = require('./vouches.controller');

var _vouches4 = _interopRequireDefault(_vouches3);

require('./vouches.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vouchComponent = {
  restrict: 'E',
  bindings: {},
  template: _vouches2.default,
  controller: _vouches4.default,
  controllerAs: 'vm'
};

exports.default = vouchComponent;


/** WEBPACK FOOTER **
 ** ./client/app/containers/vouches/vouches.component.js
 **/